import services from '@/config/services'

export default class UtilityContoAcquistoService{
  constructor(http, eventBus){
    this.http = http
    this.eventBus = eventBus
    this.baseUrl = `${services.ask_api.url}/management`
  }

  async getAll(){
    let items = []
    let totalItems = 0

    const url = `${this.baseUrl}/utility/type-pay-mode/conto-acquisto`

    try {
      let res = await this.http.get(url)
      res = res.data

      items = res.data
      totalItems = res.meta.total_items
    } catch (err) {
      this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
      this.eventBus.emit('data-loaded')
      
      // eslint-disable-next-line no-unsafe-finally
      return {
        items,
        total: totalItems
      }
    }
  }

  async create(item){

    let result = {
      conto_acquisto: null,
      success: false,
    }

    const url = `${this.baseUrl}/utility/type-pay-mode/conto-acquisto`

    try {
      let res = await this.http.post(url, {
        data: item
      })
    
      res = res.data

      result = res.data
    } catch (err) {
      this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
      this.eventBus.emit('data-loaded')
      
      // eslint-disable-next-line no-unsafe-finally
      return {
        conto_acquisto: result.conto_acquisto,
        success: result.success,
      }
    }

  }
}
